import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const createStockItemAndPart = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/parts/createStockItemAndPart`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error('Error creating part with stock item:', error.response?.data || error);
    throw error;
  }
};

export const addPartToStockItem = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/parts/addPartToStockItem`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error('Error linking part to stock item:', error.response?.data || error);
    throw error;
  }
};

export const checkDuplicatePart = async ({
  partNumber,
  oemNumber,
  sourceOfSupplyId,
  excludeId,
} = {}) => {
  try {
    const params = {
      partNumber,
      oemNumber,
    };

    if (
      sourceOfSupplyId !== undefined &&
      sourceOfSupplyId !== null &&
      sourceOfSupplyId !== ''
    ) {
      params.sourceOfSupplyId = sourceOfSupplyId;
    }

    if (excludeId !== undefined && excludeId !== null && excludeId !== '') {
      params.excludeId = excludeId;
    }

    const response = await axiosInstance.get(`${API_URL}/parts/duplicate-check`, {
      params,
    });

    return response.data;
  } catch (error) {
    console.error('Error checking duplicate part:', error.response?.data || error);
    throw error;
  }
};

export const getPartByNumberAndSource = async ({
  partNumber,
  sourceOfSupplyId,
} = {}) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/parts/by-part-number-source`,
      {
        params: { partNumber, sourceOfSupplyId },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching part by part number and source:',
      error.response?.data || error
    );
    throw error;
  }
};

// GET all tblParts
export const getParts = async ({
  page = 1,
  pageSize = 10,
  search = '',
  categoryId,
  sourceOfSupplyId,
  supplierId,
  sortField,
  sortOrder,
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts`, {
      params: { page, pageSize, search, categoryId, sourceOfSupplyId, supplierId, sortField, sortOrder },
      paramsSerializer: params => {
        const query = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching parts:", error.response?.data || error);
    throw error;
  }
};

export const getUniqueSourceOfSupply = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts/getUniqueSourceOfSupply`);
    return response.data;
  } catch (error) {
    console.error('Error fetching unique sources of supply:', error.response?.data || error);
    throw error;
  }
};

// GET a single tblParts
export const getPartsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/parts/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching parts:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new tblParts
export const createParts = async (tblPartsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/parts`, tblPartsData);
    return response.data;
  } catch (error) {
    console.error("Error creating parts:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing tblParts
export const updateParts = async (id, tblPartsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/parts/${id}`, tblPartsData);
    return response.data;
  } catch (error) {
    console.error("Error updating parts:", error.response?.data || error);
    throw error;
  }
};

// DELETE a tblParts
export const deleteParts = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/parts/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting parts:", error.response?.data || error);
    throw error;
  }
};
